// extracted by mini-css-extract-plugin
export default {"departments":"JG-z","departmentHeading":"KG-z","departmentSection":"LG-z","departmentName":"MG-z","departmentLink":"NG-z","expandIcon":"OG-z"};